/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewTodo
 */
export interface NewTodo {
    /**
     * 
     * @type {string}
     * @memberof NewTodo
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof NewTodo
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NewTodo
     */
    description: string;
}

/**
 * Check if a given object implements the NewTodo interface.
 */
export function instanceOfNewTodo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function NewTodoFromJSON(json: any): NewTodo {
    return NewTodoFromJSONTyped(json, false);
}

export function NewTodoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewTodo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'title': json['title'],
        'description': json['description'],
    };
}

export function NewTodoToJSON(value?: NewTodo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'title': value.title,
        'description': value.description,
    };
}

